import { useTranslation } from 'react-i18next';
import RadiusModal, { getRadiusLabel } from 'components/Srp/RadiusModal';
import React, { useContext, memo } from 'react';
import useEvents from 'lib/hooks/useEvents';
import { Features } from 'lib/EventSchema';
import RadiusTapEvent from 'lib/Tracking/Srp/SearchFilters/LocationFilter/RadiusTap';
import { useRadiusFilter } from 'lib/hooks/useSrpFilters';
import SrpEventContext from 'contexts/SrpEventContext';
import TopBarDropdownContainer from './TopBarDropdownContainer';

const RadiusFilterCta = memo(function RadiusFilterCta(): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const radiusFilter = useRadiusFilter();
  const label = getRadiusLabel(t, radiusFilter.value);
  const srpEventContext = useContext(SrpEventContext);

  return (
    <>
      <TopBarDropdownContainer
        title={t('srp.topBar.radius')}
        placeHolderCtaText={label}
        filter="radius"
        handleClick={(): Promise<void> =>
          logger.log(
            RadiusTapEvent({ feature: Features.srpHeader, sourcePage: srpEventContext.sourcePage })
          )
        }
      >
        <RadiusModal />
      </TopBarDropdownContainer>
    </>
  );
});

export default RadiusFilterCta;
